module.exports = __webpack_public_path__ + "static/img/preview-02.a2050270.webp";